export enum Components {
  ResetPassword = "ResetPassword",
  SignUp = "SignUp",
  SignIn = "SignIn",
  ForgotPassword = "ForgotPassword",
  Settings = "Settings",
  ChangeEmail = "ChangeEmail",
  JoinMeidly = "JoinMeidly",
  CallDetail = "CallDetail",
  InsightCalls = "InsightCalls",
  AdminUserProfile = "AdminUserProfile",
  BuyCredits = "BuyCredits",
  ProjectForm = "ProjectForm",
  AnalysisInsights = "AnalysisInsights",
  AnalysisRecommendationDetail = "AnalysisRecommendationDetail",
  ImportLinkModal = "ImportLinkModal",
  VideoAudioExtract = "VideoAudioExtract",
  CostConfirm = "CostConfirm",
  ProspectPool = "ProspectPool",
  AvatarDetail = "AvatarDetail",
  AvatarExtraction = "AvatarExtraction",
  AvatarCreationForm = "AvatarCreationForm",
  OfferForm = "OfferForm",
  OfferExtraction = "OfferExtraction",
  OfferAddChoice = "OfferAddChoice",
  SequenceStepForm = "SequenceStepForm",
  SequenceStepRegenerate = "SequenceStepRegenerate",
  SequenceGenerate = "SequenceGenerate",
  SequenceObjectiveForm = "SequenceObjectiveForm",
  SequenceVariantForm = "SequenceVariantForm",
  OfferDeletion = "OfferDeletion",
  UserAffiliation = "UserAffiliation",
  AddAffiliation = "AddAffiliation",
  EditAffiliation = "EditAffiliation",
  CompanyForm = "CompanyForm",
  CompanyDeletion = "CompanyDeletion",
  CompanyMemberForm = "CompanyMemberForm",
  MyCompanyMemberForm = "MyCompanyMemberForm",
  ProjectDeletion = "ProjectDeletion",
  CallAnalysisAutoRunConfirm = "CallAnalysisAutoRunConfirm",
  ExpertAuditConfirm = "ExpertAuditConfirm",
  ExportCall = "ExportCall",
  ExportInsight = "ExportInsight",
  ExportAvatar = "ExportAvatar",
  AddProjectMember = "AddProjectMember",
  DeleteProjectMember = "DeleteProjectMember",
  EditCallType = "EditCallType",
  DeleteCallType = "DeleteCallType",
  JobFailure = "JobFailure",
  ImportedProfileAnalysisChoice = "ImportedProfileAnalysisChoice",
  ImportedProfileAnalysisOrder = "ImportedProfileAnalysisOrder",
  ImportedProfileExtensionGuide = "ImportedProfileExtensionGuide",
  ImportedProfilesTabs = "ImportedProfilesTabs",
  ImportedProfileRejectReason = "ImportedProfileRejectReason",
  ProspectsFound = "ProspectsFound",
  ProspectForm = "ProspectForm",
  ConfirmDialog = "ConfirmDialog",
  ProspectDetail = "ProspectDetail",
  ProspectReject = "ProspectReject",
  ProspectActionConfirm = "ProspectActionConfirm",
  ProspectActionType = "ProspectActionType",
  CalendlyBooking = "CalendlyBooking",
}
